/**
 * Company & Contact Information
 */

export const CONTACT_INFO = {
  EMAIL: 'infodevamjyot@gmail.com',
  PHONE: '+91 9510127090',
};
